"use strict";

var qs = require('querystring');
var url = require('url');
var authWindow = require('../authWindow');
var _require = require('./utils'),
  erroredResponse = _require.erroredResponse,
  handleAjaxResponse = _require.handleAjaxResponse,
  sanitizeOptions = _require.sanitizeOptions;
var request = require('../../request');
module.exports = oAuth2CodeFlow;

/**
 * Trigger the full server-side OAuth2 flow.
 * Reference: http://tools.ietf.org/html/rfc6749#section-4.1
 *
 * @param {Object}   options
 */
function oAuth2CodeFlow(options) {
  try {
    options = sanitizeOptions(options);
  } catch (error) {
    return Promise.reject(error);
  }
  if (typeof options.clientId !== 'string') {
    return Promise.reject(new TypeError('"clientId" expected'));
  }
  if (typeof options.clientSecret !== 'string') {
    return Promise.reject(new TypeError('"clientSecret" expected'));
  }
  if (typeof options.accessTokenUri !== 'string') {
    return Promise.reject(new TypeError('"accessTokenUri" expected'));
  }
  if (typeof options.authorizationUri !== 'string') {
    return Promise.reject(new TypeError('"authorizationUri" expected'));
  }
  return new Promise(function (resolve, reject) {
    var state = "".concat(Math.random()).substr(2);
    var popup = authWindow("".concat(options.authorizationUri, "?").concat(qs.stringify({
      state: state,
      scope: options.scope,
      client_id: options.clientId,
      response_type: 'code',
      redirect_uri: options.redirectUri
    })), function (err) {
      if (err) {
        reject(err);
      }
      resolve();
    });

    /**
     * Assigns a global variable that the oauth authentication window should
     * be able to access and send the callback data.
     */
    global.authenticateOAuth = function (href) {
      popup.close();
      delete global.authenticateOAuth;

      // Parse the url and prepare to do an POST request to get the access token.
      var _url$parse = url.parse(href, true),
        query = _url$parse.query;
      if (href.substr(0, options.redirectUri.length) !== options.redirectUri) {
        reject(new Error('Invalid redirect URI'));
        return;
      }
      if (erroredResponse(query)) {
        reject(new Error(erroredResponse(query)));
        return;
      }
      if (query.state !== state) {
        reject(new Error('State mismatch'));
        return;
      }
      if (!query.code) {
        reject(new Error('Response code missing'));
        return;
      }
      request({
        proxy: options.proxy,
        xhr: options.xhr,
        url: options.accessTokenUri,
        method: 'POST',
        headers: {
          Accept: 'application/json, application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: qs.stringify({
          code: query.code,
          grant_type: 'authorization_code',
          redirect_uri: options.redirectUri,
          client_id: options.clientId,
          client_secret: options.clientSecret
        })
      }, function (err, xhr) {
        if (err) {
          reject(err);
          return;
        }
        try {
          resolve(handleAjaxResponse(xhr, options));
        } catch (error) {
          reject(error);
        }
      });
    };
  });
}
//# sourceMappingURL=code.js.map